module.exports = __webpack_public_path__ + "static/media/SIMULAR.1cc4efb8.jpg";